import React from 'react';

// eslint-disable-next-line react/prop-types
const LoyaltyCodeBadge = ({ loyaltyCode }) => (
  <div className="c-loyalty-code u-ta-center">
    <span className="u-text-large u-fw-bold">
      {loyaltyCode}
    </span>
  </div>
);

export default LoyaltyCodeBadge;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyGrant/components/LoyaltyCode.jsx